import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Navbar, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import {
  IconButton,
  Stack,
  Typography,
  Avatar,
  Paper,
  Grid,
  CardMedia,
  Popover,
  Divider,
  Chip,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PasswordIcon from '@mui/icons-material/Password';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import customerprofile from '../../assets/img/customerprofile.png';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import './Header.css';
import bn from 'utils/bemnames';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useStateValue } from '../../StateProvider';

const bem = bn.create('header');

const Header = () => {
  const [isOpenNotificationPopover, setIsOpenNotificationPopover] =
    useState(false);
  const [isNotificationConfirmed, setIsNotificationConfirmed] = useState(false);
  const [isOpenUserCardPopover, setIsOpenUserCardPopover] = useState(false);
  const [username, setUsername] = useState('');

  const history = useHistory();

  useEffect(() => {
    const storedUsername = sessionStorage.getItem('Username');
    setUsername(storedUsername);
  }, []);

  const toggleNotificationPopover = () => {
    setIsOpenNotificationPopover(!isOpenNotificationPopover);
    if (!isNotificationConfirmed) {
      setIsNotificationConfirmed(true);
    }
  };

  const toggleUserCardPopover = () => {
    setIsOpenUserCardPopover(!isOpenUserCardPopover);
  };

  const handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();

    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };

  const Logout = () => {
    sessionStorage.removeItem('QaInsptid');
    sessionStorage.removeItem('QainspectId');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('userid');
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('ponum');
    sessionStorage.removeItem('cateid');
    sessionStorage.removeItem('usertype');
    sessionStorage.removeItem('pono');
    sessionStorage.removeItem('authtoken');
    localStorage.clear();
  };

  const changepss = () => {
    history.push('/changepassowrd');
    handleClose();
  };
  const logout = () => {
    sessionStorage.removeItem('companyName');
    Logout();
    history.push('/logout');
    handleClose();
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <Navbar light expand className={bem.b('bg-white')}>
        <Nav navbar className="mr-2">
          <IconButton
            onClick={handleSidebarControlButton}
            sx={{ border: '1px solid', fontWeight: 600, borderRadius: '50%' }}
          >
            <MenuOpenRoundedIcon color="info" />
          </IconButton>
        </Nav>
        <Nav navbar>
          {sessionStorage.getItem('Special_User1') === 'Y' ? (
            <Stack
              direction={{ md: 'column', sm: 'column' }}
              p={1}
              spacing={0.5}
              alignItems={'flex-start'}
              justifyContent={'center'}
              display={{
                xl: 'block',
                lg: 'block',
                md: 'block',
                sm: 'block',
                xs: 'none',
              }}
              borderLeft={0.5}
              pl={2}
              borderColor={'#A2C579'}
            >
              <Typography
                variant="body1"
                color="black"
                sx={{
                  textTransform: 'capitalize',
                  fontWeight: '400',
                  color: '#17594A',
                }}
              >
                Company Name :{' '}
                <span>{sessionStorage.getItem('companyName')}</span>
              </Typography>
            </Stack>
          ) : (
            <Stack
              direction={{ md: 'column', sm: 'column' }}
              p={1}
              spacing={0.5}
              alignItems={'flex-start'}
              justifyContent={'center'}
              display={{
                xl: 'block',
                lg: 'block',
                md: 'block',
                sm: 'block',
                xs: 'none',
              }}
              borderLeft={0.5}
              pl={2}
              borderColor={'#A2C579'}
            >
              <Typography
                variant="body1"
                color="black"
                sx={{
                  textTransform: 'capitalize',
                  fontWeight: '400',
                  color: '#17594A',
                }}
              >
                Customer : <span>{sessionStorage.getItem('CustomerName')}</span>
              </Typography>
              {sessionStorage.getItem('customer_HO') === 'N' ? (
                <Typography
                  variant="caption"
                  color="secondary"
                  sx={{ textTransform: 'capitalize' }}
                >
                  Branch Name :
                  <span>
                    {sessionStorage.getItem('CBranchName') === 'null'
                      ? sessionStorage.getItem('Customer_Name')
                      : sessionStorage.getItem('CBranchName')}
                  </span>
                </Typography>
              ) : (
                <Typography
                  variant="caption"
                  color="#61677A"
                  sx={{ textTransform: 'capitalize' }}
                >
                  {/* HO Name : */}{' '}
                  {/* <span>{sessionStorage.getItem('CustomerHo_Name')}</span> */}
                </Typography>
              )}
            </Stack>
          )}
        </Nav>

        <Nav navbar className={bem.e('nav-right')}>
          <NavItem style={{ borderRadius: '6px' }}>
            <NavLink id="Popover2">
              <IconButton
                aria-label=""
                aria-describedby={id}
                onClick={handleClick}
                sx={{ border: '1px solid grey', boxShadow: 2 }}
              >
                <AccountCircleIcon color="success" />
              </IconButton>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <List>
                  {/* {sessionStorage.getItem('CustomerLogin') !== 'YES' && ( */}
                    <>
                      <Divider />
                      <ListItem>
                        <ListItemIcon>
                          <AssignmentIndIcon color="primary" />
                        </ListItemIcon>

                        <Typography variant="body2" color="GrayText">
                          {sessionStorage.getItem('Username')}
                        </Typography>
                      </ListItem>
                      <Divider />
                    </>
                  {/* )} */}
                  {
                  // sessionStorage.getItem('AdminUser') !== 'Y' &&
                    sessionStorage.getItem('Special_User1') !== 'Y' && (
                      <>
                        <ListItem>
                          <ListItemIcon>
                            <LocationCityIcon color="secondary" />
                          </ListItemIcon>
                          <Typography variant="body2" color="GrayText">
                            Company:
                            <br />
                            {sessionStorage.getItem('companyName')}
                          </Typography>
                        </ListItem>
                        <Divider />
                        <ListItem>
                          <ListItemButton onClick={changepss}>
                            <ListItemIcon>
                              <PasswordIcon color="success" />
                            </ListItemIcon>
                            <ListItemText
                              primary="Change Password"
                              primaryTypographyProps={{ fontSize: '15px' }}
                            />
                          </ListItemButton>
                        </ListItem>

                        <Divider />
                      </>
                    )}

                  <ListItem>
                    <ListItemButton onClick={logout}>
                      <ListItemIcon>
                        <ExitToAppIcon color="success" />
                      </ListItemIcon>
                      <ListItemText
                        primary="Log Out"
                        primaryTypographyProps={{ fontSize: '15px' }}
                      />
                    </ListItemButton>
                  </ListItem>
                </List>
              </Popover>
            </NavLink>
          </NavItem>
        </Nav>
      </Navbar>

      {sessionStorage.getItem('Special_User1') === 'Y' ? null : (
        <Stack
          component={Paper}
          elevation={4}
          className={bem.b('bg-white')}
          direction={{ md: 'column', sm: 'column' }}
          p={1}
          spacing={0.5}
          alignItems={'center'}
          justifyContent={'center'}
          display={{
            xl: 'none',
            lg: 'none',
            md: 'none',
            sm: 'none',
            xs: 'block',
          }}
          mx={2}
          textAlign={'left'}
        >
          <Grid
            container
            spacing={1}
            direction={'row'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Grid item xs={3}>
              <CardMedia
                component="img"
                alt="profile image"
                image={customerprofile}
                style={{
                  width: '100%',
                  maxHeight: '10vh',
                  objectFit: 'contain',
                  mixBlendMode: 'multiply',
                }}
              />
            </Grid>

            <Grid item xs={9} borderLeft={0.5} pl={1} borderColor={'#A2C579'}>
              <Typography
                variant="body2"
                color="black"
                sx={{
                  textTransform: 'capitalize',
                  fontWeight: '400',
                  color: '#17594A',
                }}
              >
                Customer :<br />{' '}
                <span style={{ fontWeight: 600 }}>
                  {sessionStorage.getItem('CustomerName')}
                </span>
              </Typography>
              {sessionStorage.getItem('customer_HO') === 'N' ? (
                <Typography
                  variant="caption"
                  color="secondary"
                  sx={{ textTransform: 'capitalize' }}
                >
                  Branch Name :
                  <span>
                  {sessionStorage.getItem('CBranchName') === 'null'
                      ? sessionStorage.getItem('Customer_Name')
                      : sessionStorage.getItem('CBranchName')}
                  </span>
                </Typography>
              ) : (
                <Typography
                  variant="caption"
                  color="#61677A"
                  sx={{ textTransform: 'capitalize' }}
                >
                  HO Name :{' '}
                  <span>{sessionStorage.getItem('CustomerHo_Name')}</span>
                </Typography>
              )}
            </Grid>
          </Grid>
        </Stack>
      )}
    </>
  );
};

export default Header;
